module.exports = __webpack_public_path__ + "static/media/C13.bfa27b9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/C13.mp4
// module id = NkYu
// module chunks = 8